import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import {useMandanteMutations} from '../../hooks/mandantes/useMandanteMutations';
import { ButtonSubmit, FooterPages } from '..';

const initialState = {
empresa:'',
rutCliPro: '',
razonSocial: '',
giro: '',
direccion: '',
telefono: '',
email: '',
descripcion: '',
comuna: '',
ciudad: '',
contacto: '',
estado: 'Activo',
};

const NuevoMandante = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const { addMandante, updateMandanteD } = useMandanteMutations();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  useEffect(() => {
    if(vecinoData) setFormData(vecinoData);
  }, [vecinoData]);

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) =>{
    e.preventDefault();

    // Validaciones

    if(!vecinoData._id) 
    {
       await addMandante.mutateAsync( formData );
    } else
    {
      // dispatch(updateProduct(prodData));    
       await updateMandanteD.mutateAsync( formData );
    };
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevomandante );

  }
  
  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
        <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-white w-full md:w-2/3 p-8">
          
            <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
              <div className="flex items-center gap-2">
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
                <p className="text-gray-800 font-semibold text-base md:text-lg">
                  {!vecinoData ? "Nuevo" : "Editar"} Mandante
                </p>
              </div>

              <button
                type="button"
                onClick={() => setIsClicked(!isClicked.nuevomandante)}
                className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
                aria-label="Cerrar"
              >
                <MdOutlineCancel className="text-xl md:text-2xl" />
              </button>
            </div>
          
          <div className="mt-5 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
                <div className="flex flex-col">
                  <p className="text-xs text-gray-600"> Rut* </p>
                  <input
                      className={inputClass}
                      type="text"
                      placeholder=""
                      name="rutCliPro"
                      value= {formData.rutCliPro}
                      required
                      onChange={handleChange}
                    />
                </div>
                <div className="col-span-3">
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Razón Social* </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="razonSocial"
                        value= {formData.razonSocial}
                        required
                        onChange={handleChange}
                      />
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" >
                <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Giro </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="giro"
                        value= {formData.giro}
                        required
                        onChange={handleChange}
                      />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Dirección </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="direccion"
                        value= {formData.direccion}
                        onChange={handleChange}
                      />
                  </div> 
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" >
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Comuna </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder="Comuna"
                        name="comuna"
                        value= {formData.comuna}
                        onChange={handleChange}
                      />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Ciudad </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder="Ciudad"
                        name="ciudad"
                        value= {formData.ciudad}
                        required
                        onChange={handleChange}
                      />
                  </div> 
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Contacto </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder="Contacto"
                        name="contacto"
                        value= {formData.contacto}
                        onChange={handleChange}
                      />
                  </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4" >
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Teléfono </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder="Teléfono"
                        name="telefono"
                        value= {formData.telefono}
                        onChange={handleChange}
                      />
                  </div>  
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> email </p>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder="email"
                        name="email"
                        value= {formData.email}
                        onChange={handleChange}
                      />
                  </div>
                  <div className="flex flex-col">
                    <p className="text-xs text-gray-600"> Estado* </p>
                      <select className={inputClass} name="estado" value= {formData.estado} required onChange={handleChange}>
                        <option value="ACTIVO">Activo</option>
                        <option value="INACTIVO">Inactivo</option>
                        <option value="ELIMINADO">Eliminado</option>
                      </select>
                  </div>
              </div>

              <div className="grid grid-cols-1 gap-4" >
                  <div className="flex flex-col">
                      <ButtonSubmit
                        color="white"
                        bgColor={currentColor}
                        text= { !vecinoData ? "Crear Nuevo": "Guardar Cambios"}  
                        borderRadius="10px"
                        onClick = {handleSubmit}
                        width="full"
                      />   
                  </div>
              </div>           
              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevoMandante;